var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgParkingSpaces = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#717680",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  clipPath: "url(#parkingSpaces_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.333 13.333V6.667h2.779c.766 0 1.388.745 1.388 1.666S11.878 10 11.112 10H8.333"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.5 10a7.5 7.5 0 1 0 15 0 7.5 7.5 0 0 0-15 0"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "parkingSpaces_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));
export default SvgParkingSpaces;